import { useState } from "react";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqItems } from "@/mocks/comics";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="mx-auto w-full max-w-4xl px-4 py-8 md:px-6 md:py-12">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqItems.map((item) => ({
              "@type": "Question",
              name: item.q,
              acceptedAnswer: { "@type": "Answer", text: item.a },
            })),
          }),
        }}
      />

      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />

      <div className="mt-6">
        <h1 className="text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h1>
        <p className="mt-2 text-sm text-foreground-600">
          关于无尽漫画网的追更进度、连载状态与最新话查询，这里有你想知道的答案。
        </p>
      </div>

      <div className="mt-8 space-y-3">
        {faqItems.map((item, idx) => (
          <div key={item.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <button
              onClick={() => setOpen(open === idx ? null : idx)}
              className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
            >
              <span className="text-sm font-medium text-foreground-900 md:text-base">{item.q}</span>
              <i className={`ri-add-line shrink-0 text-lg text-primary-500 transition-transform ${open === idx ? "rotate-45" : ""}`}></i>
            </button>
            {open === idx && <p className="prose-line px-4 pb-4 text-sm text-foreground-700 md:px-5">{item.a}</p>}
          </div>
        ))}
      </div>

      <div className="mt-10 rounded-lg bg-background-100/80 px-5 py-8 text-center">
        <i className="ri-customer-service-2-line text-3xl text-primary-500"></i>
        <h2 className="mt-3 text-lg font-semibold text-foreground-950">还有问题想问？</h2>
        <p className="mx-auto mt-2 max-w-md text-sm text-foreground-600">
          如果你发现漏更或信息有误，欢迎通过邮件联系我们，我们会尽快核实修正。
        </p>
        <a
          href="mailto:support@wujinmanhua.com"
          className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap hover:bg-primary-600"
        >
          <i className="ri-mail-send-line"></i> 联系客服
        </a>
      </div>
    </div>
  );
}